import { render } from "./FilterSubCategory.vue?vue&type=template&id=3a5e50df"
import script from "./FilterSubCategory.vue?vue&type=script&lang=js"
export * from "./FilterSubCategory.vue?vue&type=script&lang=js"
script.render = render

export default script